import { get_narrations, get_payee_accounts } from "../api/index.ts";
import { notify_err } from "../notifications.ts";
class FetchCoalescer {
  data = $state.raw();
  #loader;
  #error_msg;
  #mtime = null;
  #inflight = null;
  constructor(loader, error_msg) {
    this.#loader = loader;
    this.#error_msg = error_msg;
  }
  /** Fetch the data, reusing cached data or a parallel fetch operation that is in flight. */
  load(mtime) {
    if (this.data != null && this.#mtime === mtime) {
      return this;
    }
    if (this.#inflight) {
      return this;
    }
    this.#inflight = this.#loader().then((data) => {
      this.data = data;
      this.#mtime = mtime;
      this.#inflight = null;
    }).catch((error) => {
      notify_err(error, (err) => this.#error_msg(err));
      this.#inflight = null;
    });
    return this;
  }
}
const narrations = new FetchCoalescer(
  get_narrations,
  (err) => `Fetching narration suggestions failed: ${err.message}`
);
export function fetch_narrations(mtime) {
  return narrations.load(mtime);
}
const payee_accounts = /* @__PURE__ */ new Map();
export function fetch_payee_accounts(mtime, payee) {
  let fetcher = payee_accounts.get(payee);
  if (fetcher == null) {
    fetcher = new FetchCoalescer(
      async () => get_payee_accounts({ payee }),
      (err) => `Fetching account suggestions for payee '${payee}' failed: ${err.message}`
    );
    payee_accounts.set(payee, fetcher);
  }
  return fetcher.load(mtime);
}
